import React,{useState,useRef,useEffect} from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import Cleave from 'cleave.js/react'
import parse from 'html-react-parser'
import { Formik, Field, FieldArray } from 'formik'
import { Form, Input, TextArea, Button, Select, Step, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import Spinner from '../../services/spinner'
import AlertMessage from '../../services/alert'
import AlertConfirmation from '../../services/confirmation'
import { WindowReload, WindowURL, WindowLocation, RouteURL, RedirectURL } from '../../services/redirect'
import { ValidateForm } from '../../validations/schemaCustomer'
import { DropdownComponent } from '../../components/options'
import AuthDenied from '../ErrorPage/denied'


export default function DetailsOrderComponent(props){

  const params = useParams();


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);
  const [statusSpinner,setstatusSpinner] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
    }
  }


  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
    }
  }


  /*------------------------------------------------------
    ALERT CONFIRMATION
    {intent:'delete',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Delete Confirmation!',text:'This process is not ireversible. Once you continue the process, the record will be deleted forever on the database.'}}
  -------------------------------------------------------*/
  const [confirm,setconfirm] = useState(true);
  const [confirmcontent, setconfirmcontent] = useState({});
  function Confirmcallback(data){
    if(data.intent=='close'){
      setconfirm(false);
      if(data.reload){
        WindowReload();
      }
    }
    if(data.intent=='confirm'){
      DeleteRecord(data.id);
    }
    if(data.intent=='statconfirm'){
      StatusOrderRecord(data.id);
    }
  }



  /*----------------------------------------
    Handle Details Order
  -----------------------------------------*/
  const [state, setState] = useState({
    id:'',
    date_order:'',
    time_order:'',
    order_number:'',
    account_number:'',
    account_type:'',
    account_name:'',
    product_code:'',
    product_name:'',
    quantity:'',
    price:'',
    total:'',
    status:'',
    statusHtml:'',
    date_process:'',
    info_process:'',
    sat_delivery:'',
    address:{},

    account:{
      id:'',
      account_number:'',
      account_name:'',
      email:'',
      activities:'',
      status:'',
      status_pricing:'',
      comments:'',
      account_type:'',
      address:[],
    },
    processing_notes:[]
  });


  function OrderDetails(id){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','details');
    formData.append('id',id);
    axios.post('/admin/orders/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);

      if(obj==0){
        WindowLocation('/orders/list');
        return false;
      }

      setState({
        ...state,
        id:obj.id,
        date_order:obj.date_order,
        time_order:obj.time_order,
        order_number:obj.order_number,
        account_number:obj.account_number,
        account_type:obj.account_type,
        account_name:obj.account_name,
        product_code:obj.product_code,
        product_name:obj.product_name,
        quantity:obj.quantity,
        price:obj.price,
        total:obj.total,
        status:obj.status,
        statusHtml:obj.statusHtml,
        date_process:obj.date_process,
        info_process:obj.info_process,
        sat_delivery:obj.sat_delivery,
        address:obj.address,
        account:obj.account,
        //processing_notes:obj.processing_notes
      });


    })
    .catch(function (error){
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);
    });
  }


  /*------------------------------------------------------
          DELETE FUNCTION
  -------------------------------------------------------*/
  function DeleteConfirmation(id){
    setconfirmcontent({intent:'delete',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Delete Confirmation!',text:'Once you continue the process, this order will be deleted.'}});
    setconfirm(true);
  }


  function DeleteRecord(id){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setspinner(true);
    setconfirm(false);

    let formData = new FormData();
    formData.append('type','delete');
    formData.append('id',id);
    axios.post('/admin/orders/request.php',formData)
    .then(function (response) {
        let obj = response.data;

        setspinner(false);

        if(obj=='success'){
          setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully deleted.'}});
          setnotify(true);
          setTimeout(function() {
            WindowLocation('/orders/list');
          },2000);
        }else{
          setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Delete Failed',text:'Record not successfully deleted.'}});
          setnotify(true);
          setTimeout(function() {
            setnotify(false);
          },2000);
        }

    })
    .catch(function (error){
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });
}


/*------------------------------------------------------
        STATUS FUNCTION
-------------------------------------------------------*/
function StatusConfirmation(id,status){

  const data = {
    id:id,
    status:status
  }

  var title = "Undo In Progress Confirmation";
  var text  = "Are you sure you want to undo the status? The order status will go back from In Progress to New order.";

  if(status==2){
     title = "Undo Processed Confirmation";
     text  = "Are you sure you want to undo the status? The order status will go back from Processed to In Progress.";
  }

  setconfirmcontent({intent:'confirmation',settings:{id:data,centered:false,onclose:true,icon:'warning',title:title,text:text}});
  setconfirm(true);

}


function StatusOrderRecord(data){

  setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
  setstatusSpinner(true);
  setconfirm(false);

  let formData = new FormData();
  formData.append('type','status');
  formData.append('id',data.id);
  formData.append('status',data.status);
  axios.post('/admin/orders/request.php',formData)
  .then(function (response) {
      let obj = response.data;

      setstatusSpinner(false);

      if(obj=='success'){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Status successfully updated.'}});
        setnotify(true);
        setTimeout(function() {
          WindowReload();
        },2000);
      }else{
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Status Failed',text:'Status not successfully updated.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},2000);
      }

  })
  .catch(function (error){
    setstatusSpinner(true);
    setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
    setnotify(true);
  });
}




  /*---------------------------------------------------------------------------------------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  ----------------------------------------------------------------------------------------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('49kgqvft618ydxzep');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;
        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        if(obj.view==1){
            if(params.id){
              OrderDetails(params.id);
            }else{
              WindowLocation('/customers/list');
              return false;
            }
        }
        setloader(false);
        setspinner(false);

    })
    .catch(function (error){
      setloader(false);
      setnofitycontent({intent:'error',settings:{onclose:false,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });
 }

  useEffect(()=>{
    AuthPagesPermission();
  },[]);

  return (
    <React.Fragment>

      {confirm&&<AlertConfirmation data={confirmcontent} callback={Confirmcallback}/>}
      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {loader&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {statusSpinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

      {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}

      {(authPages['view']==0&&!loader)&&<AuthDenied/>}
      {(authPages['view']==1&&!loader)&&<React.Fragment>

      <div className="page-wrapper-one">
        <div className="app-page-title">
         <div className="page-title-wrapper">
            <div><h1>Order Details</h1></div>
            <div>
              <Button className='LightGrayButton strong' size='tiny' content='Refresh' icon='sync alternate icon' onClick={()=>WindowReload()}/>
              <Button className='GreenButton strong' size='tiny' content='Back to list' icon='arrow left icon' as="a" href={WindowURL('/orders/list')}/>
            </div>
          </div>
         </div>
          <div className="app-body-wrapper">

            <div className="page-form-panel">
                <div className="page-form-header"><h3>Customer Details</h3></div>
                <div className="page-form-body">

      
                       <Table className="noBorder">
                           <Table.Body>
                             <Table.Row>
                               <Table.Cell width={3}><strong>Account Number</strong></Table.Cell>
                               <Table.Cell>{state.account.account_number}</Table.Cell>
                             </Table.Row>
                             <Table.Row>
                               <Table.Cell><strong>Account Name</strong></Table.Cell>
                               <Table.Cell>{state.account.account_name}</Table.Cell>
                             </Table.Row>

                             <Table.Row>
                               <Table.Cell><strong>Account Type</strong></Table.Cell>
                               <Table.Cell>{parse(state.account_type)}</Table.Cell>
                             </Table.Row>
                             
                             </Table.Body>
                         </Table>

                        

                </div>{/*.page-form-body*/}
             </div>{/*.page-form-panel*/}


             <br/>


             <div className="page-form-panel">
                <div className="page-form-header"><h3>Order Delivery Address</h3></div>
                <div className="page-form-body">

                       <Table className="noBorder">
                           <Table.Body>

                             {state.address.pharmacy!=''&&<Table.Row>
                               <Table.Cell><strong>Pharmacy</strong></Table.Cell>
                               <Table.Cell>{state.address.pharmacy}</Table.Cell>
                             </Table.Row>}

                             {state.address.reference!=''&&<Table.Row>
                               <Table.Cell><strong>Reference</strong></Table.Cell>
                               <Table.Cell>{state.address.reference}</Table.Cell>
                             </Table.Row>}

                             <Table.Row>
                               <Table.Cell width={3}><strong>Phone</strong></Table.Cell>
                               <Table.Cell>{state.address.phone}</Table.Cell>
                             </Table.Row>

                             <Table.Row>
                               <Table.Cell><strong>Address Line 1</strong></Table.Cell>
                               <Table.Cell>{state.address.line_1}</Table.Cell>
                             </Table.Row>
                             <Table.Row>
                               <Table.Cell><strong>Address Line 2</strong></Table.Cell>
                               <Table.Cell>{state.address.line_2}</Table.Cell>
                             </Table.Row>
                             <Table.Row>
                               <Table.Cell><strong>Address Line 3</strong></Table.Cell>
                               <Table.Cell>{state.address.line_3}</Table.Cell>
                             </Table.Row>

                             <Table.Row>
                               <Table.Cell><strong>City</strong></Table.Cell>
                               <Table.Cell>{state.address.city}</Table.Cell>
                             </Table.Row>

                             <Table.Row>
                               <Table.Cell><strong>County</strong></Table.Cell>
                               <Table.Cell>{state.address.county}</Table.Cell>
                             </Table.Row>

                             <Table.Row>
                               <Table.Cell><strong>Postal Code</strong></Table.Cell>
                               <Table.Cell>{state.address.postal_code}</Table.Cell>
                             </Table.Row>

                             <Table.Row>
                               <Table.Cell><strong>Country</strong></Table.Cell>
                               <Table.Cell>{state.address.country}</Table.Cell>
                             </Table.Row>
                             
                             </Table.Body>
                         </Table>

            
                </div>{/*.page-form-body*/}
             </div>{/*.page-form-panel*/}




             <br/>
          </div>
        </div>

        {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
        {!spinner&&<React.Fragment>

          
        <div className="page-form-panel">
            <div className="page-form-header"><h3>Order Details</h3></div>
            <div className="page-form-body">

            <div className="table-responsive">
              <Table celled compact='very' className="ordersTable">
                <Table.Header>
                  <Table.Row verticalAlign='middle'>
                    <Table.HeaderCell>Date</Table.HeaderCell>
                    <Table.HeaderCell>Order Number</Table.HeaderCell>
                    <Table.HeaderCell>Account Number</Table.HeaderCell>
                    <Table.HeaderCell>Pharmacy</Table.HeaderCell>
                    <Table.HeaderCell>Product Code</Table.HeaderCell>
                    <Table.HeaderCell>Product</Table.HeaderCell>
                    <Table.HeaderCell>Status</Table.HeaderCell>
                    <Table.HeaderCell>Quantity</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                    <Table.Row verticalAlign='top'>
                        <Table.Cell className="now-wrapp">
                           <div className="descriptionTable">
                             <div>
                                 <h3>{state.date_order}</h3>
                                 <p>{state.time_order}</p>
                             </div>
                           </div>
                        </Table.Cell>
                        <Table.Cell>{state.order_number}</Table.Cell>
                        <Table.Cell>{state.account_number}</Table.Cell>
                        <Table.Cell>{state.account_name}</Table.Cell>
                        <Table.Cell>{state.product_code}</Table.Cell>
                        <Table.Cell>{state.product_name}</Table.Cell>
                        <Table.Cell>{state.statusHtml!=''?parse(state.statusHtml):''}</Table.Cell>
                        <Table.Cell collapsing>{state.quantity}</Table.Cell>
                    </Table.Row>
                  </Table.Body>

                  {(state.sat_delivery==1||state.status>1)&&<React.Fragment>
                    <Table.Footer fullWidth>
                        <Table.Row>
                        <Table.HeaderCell colSpan='8'>

                          {state.sat_delivery==1&&<div className="statusWrapperDetails">
                            <div className='alert-message centerFlex left success'>
                              <div><i class="uil-check-circle icon"></i></div>
                              <div>
                                <p>Saturday Delivery Required.</p>
                               </div>
                            </div>
                          </div>}

                          {state.status>1&&<div className="statusWrapperDetails">
                            <div className={state.status==2?'alert-message left warning':'alert-message left success'}>
                              <div><i className={state.status==2?'uil-clock-nine icon':'uil-check-circle icon'}></i></div>
                              <div>
                                <p style={{'font-weight':'600'}}>{state.date_process}</p>
                                <p>{state.info_process}</p>
                               </div>
                            </div>
                          </div>}

                        </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                  </React.Fragment>}


              </Table>


             </div>{/*.table-responsive*/}
            </div>{/*.page-form-body*/}
         </div>{/*.page-form-panel*/}



         {state.processing_notes.length>0&&<React.Fragment>
          <div className="page-form-panel" style={{'margin-top':'15px'}}>
            <div className="page-form-header"><h3>Processing Note</h3></div>
            <div className="page-form-body">

            <div className="table-responsive">
              <Table celled compact='very' className="ordersTable">
                <Table.Header>
                  <Table.Row verticalAlign='middle'>
                    <Table.HeaderCell>Account Number</Table.HeaderCell>
                    <Table.HeaderCell>Account Name</Table.HeaderCell>
                    <Table.HeaderCell>Product</Table.HeaderCell>
                    <Table.HeaderCell>Quantity</Table.HeaderCell>
                    <Table.HeaderCell>Price</Table.HeaderCell>
                    <Table.HeaderCell>Carriage</Table.HeaderCell>
                    <Table.HeaderCell>Handling Fee</Table.HeaderCell>
                    <Table.HeaderCell>Note</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                    {state.processing_notes.map(function(data, key){
                      return<Table.Row verticalAlign='top'>
                          <Table.Cell>{data.account_number}</Table.Cell>
                          <Table.Cell>{data.account_name}</Table.Cell>
                          <Table.Cell>
                            <div className="descriptionTable">
                              <div>
                                  <div style={{'opacity':'0.8'}}>{data.product_code}</div>
                                  <h3>{data.product_name}</h3>
                              </div>
                            </div>
                         </Table.Cell>
                        <Table.Cell>{data.quantity}</Table.Cell>
                        <Table.Cell>{data.price}</Table.Cell>
                        <Table.Cell>{data.carriage}</Table.Cell>
                        <Table.Cell>{data.handling_fee}</Table.Cell>
                        <Table.Cell>{data.note}</Table.Cell>
                      </Table.Row>
                    })}
                  </Table.Body>
              </Table>


             </div>{/*.table-responsive*/}
            </div>{/*.page-form-body*/}
         </div>{/*.page-form-panel*/}
         </React.Fragment>
         }


  

         <div className="buttonPageFooter">
            <Button size='small' className='GreenButton strong' content='Back to list' icon='arrow left icon' as="a" href={WindowURL('/orders/list')}/>
            {/*state.status==2&&<Button size='small' className='DarkButton strong' content='Undo In Progress' icon='uil-history-alt icon' onClick={()=>StatusConfirmation(state.id,1)}/>*/}
            {/*state.status==3&&<Button size='small' className='DarkButton strong' content='Undo Processed' icon='uil-history-alt icon' onClick={()=>StatusConfirmation(state.id,2)}/>*/}
            <Button size='small' disabled={state.status>1||authPages['deleting']==0} className='RedButton strong' content='Delete Order' icon='uil-trash-alt icon' onClick={()=>DeleteConfirmation(state.id)}/>
         </div>

        </React.Fragment>}

      </React.Fragment>}
    </React.Fragment>
  )
}
